import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "timer-group" }
const _hoisted_2 = {
  key: 0,
  class: "focus-label"
}
const _hoisted_3 = { id: "selected-task" }
const _hoisted_4 = {
  key: 1,
  class: "focus-label"
}
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","margin-top":"2rem"} }
const _hoisted_6 = { style: {"display":"grid","grid-template-columns":"fit-content(40%) fit-content(40%)","box-sizing":"border-box"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", null, "st", -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "Smooth Pomodoro - by Nicolas Guruphat"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.flaticon.com/authors/pixel-perfect",
    title: "tomato icons"
  }, "Tomato icons created by Pixel perfect - Flaticon"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", { href: "https://freesound.org/people/InspectorJ/sounds/411575/" }, "Sound effect by InspectorJ - Freesound")
], -1)

import { useParameters } from '@/store/Parameters'
import ActionButton from './components/ActionButton.vue'
import StatistiquesBlock from './components/StatistiquesBlock.vue'
import OptionsBlock from './components/OptionsBlock.vue'
import ProgressBar from './components/ProgressBar.vue'
import TodoList from './components/TodoList.vue'
import { ref, computed, watchEffect } from 'vue'
import fullscreenLogo from '@/assets/fullscreen.svg'
import { useFullscreen, useFavicon, useDraggable } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { useUser } from './store/User'

import type Task from '@/interfaces/Task'
import type TimerReturn from './interfaces/composable/TimerReturn'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

function useTimer () : TimerReturn {
  function checkTime (): void {
    if (minutes.value < 0) {
      switchSession()
    }
    if (seconds.value < 0) {
      seconds.value = 59
      minutes.value--
      if (minutes.value < 0) {
        switchSession()
      }
    }
  }
  const clock = ref<HTMLElement | null>(null)
  const intervalId = ref<number | null>(null)
  const startTimer = (): void => {
    intervalId.value = setInterval(() => {
      seconds.value--
    }, 1000)
  }
  const stopTimer = (): void => {
    if (intervalId.value !== null) {
      clearInterval(intervalId.value)
      intervalId.value = null
    }
  }
  const timer = computed(() => {
    checkTime()
    const minutesToDisplay: string = minutes.value < 10 ? '0' + minutes.value : minutes.value.toString()
    const secondsToDisplay: string = seconds.value < 10 ? '0' + seconds.value : seconds.value.toString()
    return minutesToDisplay + ':' + secondsToDisplay
  })
  function addOneMinute (): void {
    minutes.value++
  }

  function removeOneMinute (): void {
    minutes.value--
  }
  const blinkIntervalId = ref<number | null>(null)
  const blink = ref(true)
  const blinking = ref(true)
  const startBlink = (): void => {
    console.log('here')
    blinking.value = true
    blinkIntervalId.value = setInterval(() => {
      if (clock.value == null) {
        return
      }
      blink.value = !blink.value
    }, 1000)
  }
  const stopBlink = (): void => {
    if (blinkIntervalId.value !== null) {
      clearInterval(blinkIntervalId.value)
      intervalId.value = null

      if (clock.value == null) {
        return
      }
      blink.value = false
      blinking.value = false
    }
  }
  return { clock, timer, blinking, blink, startTimer, stopTimer, addOneMinute, removeOneMinute, startBlink, stopBlink }
}

function useIcon () : void {
  const { blinking } = useTimer()
  const icon = useFavicon()
  icon.value = 'orangeTomato.png'

  function changeIcon (color: string): void {
    switch (color) {
      case 'green':
        icon.value = 'greenTomato.png'
        break
      case 'red':
        icon.value = 'redTomato.png'
        break
      case 'orange':
        icon.value = 'orangeTomato.png'
        break
    }
  }
  watchEffect(() => {
    if (blinking.value) {
      changeIcon('orange')
    } else {
      if (working.value) {
        changeIcon('red')
      } else {
        changeIcon('green')
      }
    }
  })
}

function useReset () : { globalReset: ()=>void; resetTimer: () => void; clearData: () => void} {
  function globalReset (): void {
    resetTimer()
    totalPomodoriDone.value = 0
    currentPomodoroNumber.value = 1
  }

  function resetTimer (): void {
    minutes.value = pomodoroTime.value.minutes
    seconds.value = pomodoroTime.value.seconds
    working.value = true
  }

  const clearData = (): void => {
    if (!confirm("You're about to delete all of your data (except task list).\nAre you sure you want to do that ? 🧹")) {
      return
    }
    parameters.reset()
    user.reset()
  }
  return { globalReset, resetTimer, clearData }
}

const app = ref(null)
const showTodo = ref<boolean>(true)
const selectedTask = ref<Task | null>(null)
const todoList = ref<HTMLElement | null>(null)

useIcon()
const { globalReset, resetTimer, clearData } = useReset()
const { clock, timer, blink, startTimer, stopTimer, addOneMinute, removeOneMinute, startBlink, stopBlink } = useTimer()
const parameters = useParameters()
const user = useUser()
const { isFullscreen, toggle } = useFullscreen(app)
const { style } = useDraggable(todoList, {
  initialValue: { x: 40, y: 40 }
})

const { currentPomodoroNumber, totalPomodoriDone, minutes, seconds } = storeToRefs(user)
const { pomodoroTime, breakTime, audioEnabled, gradiantEnabled, pomodoriByCycle, goal } = storeToRefs(parameters)

startBlink()

const startOrStopLabel = ref<'START' | 'STOP'>('START')
function startOrStop (): void {
  if (startOrStopLabel.value === 'STOP') {
    startOrStopLabel.value = 'START'
    stopTimer()
    startBlink()
  } else {
    startOrStopLabel.value = 'STOP'
    stopBlink()
    startTimer()
  }
}
// eslint-disable-next-line @typescript-eslint/no-var-requires
const soundEffect = ref<HTMLMediaElement>(new Audio(require('./assets/gong_hit.wav')))

const working = ref<boolean>(true)
function switchSession (): void {
  if (audioEnabled.value) {
    soundEffect.value.play()
  }
  if (working.value) {
    // switch to pause session
    if (currentPomodoroNumber.value === pomodoriByCycle.value) {
      minutes.value = breakTime.value.big.minutes
      seconds.value = breakTime.value.big.seconds
    } else {
      minutes.value = breakTime.value.small.minutes
      seconds.value = breakTime.value.small.seconds
    }
    totalPomodoriDone.value += 1
  } else {
    // switch to work session
    currentPomodoroNumber.value = (currentPomodoroNumber.value) % pomodoriByCycle.value + 1
    minutes.value = pomodoroTime.value.minutes
    seconds.value = pomodoroTime.value.seconds
  }
  working.value = !working.value
}

const progressBackgroundGradiant = computed(() => {
  if (gradiantEnabled.value) {
    const baseTime: number = working.value ? pomodoroTime.value.minutes * 60 + pomodoroTime.value.seconds : breakTime.value.small.minutes * 60 + breakTime.value.small.seconds * 60
    const currentTime: number = baseTime - (minutes.value * 60 + seconds.value)
    if (working.value) {
      const progression: number = ((currentTime / baseTime) - 1 / 3) * 100 * 3 * -1

      return {
        background: `linear-gradient(75deg, #ffb5aa ${progression}%, #aaffb6 100%)`
      }
    } else {
      const progression: number = ((currentTime / baseTime) - 0.2) * 100 * 5 * -1
      return {
        background: `linear-gradient(-105deg, #aaffb6 ${progression}%, #ffb5aa 100%)`
      }
    }
  } else {
    return { 'background-color': working.value ? '#ffb5aa' : '#aaffb6' }
  }
})

function skipCurrentPomodoro (): void {
  minutes.value = 0
  seconds.value = 0
  seconds.value--
}

function goBackToFirstPomodoro (): void {
  // go back to the first pomodoro of the current cycle
  if (working.value) {
    totalPomodoriDone.value -= (currentPomodoroNumber.value - 1)
  } else {
    totalPomodoriDone.value -= currentPomodoroNumber.value
  }
  currentPomodoroNumber.value = 1
  resetTimer()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "progress-background-base",
    style: _normalizeStyle(progressBackgroundGradiant.value)
  }, [
    _createVNode(StatistiquesBlock, {
      class: "stats-block",
      currentPomodoroNumber: _unref(currentPomodoroNumber),
      pomodoriByCycle: _unref(pomodoriByCycle),
      totalPomodoriDone: _unref(totalPomodoriDone),
      goal: _unref(goal),
      timer: _unref(timer)
    }, null, 8, ["currentPomodoroNumber", "pomodoriByCycle", "totalPomodoriDone", "goal", "timer"]),
    _createVNode(OptionsBlock, {
      class: "options-block",
      showTodo: showTodo.value,
      "onUpdate:showTodo": _cache[0] || (_cache[0] = ($event: any) => ((showTodo).value = $event))
    }, null, 8, ["showTodo"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ActionButton, {
        class: "minute-button",
        id: "remove-one-minute-button",
        action: _unref(removeOneMinute)
      }, {
        default: _withCtx(() => [
          _createTextVNode("<")
        ]),
        _: 1
      }, 8, ["action"]),
      _createElementVNode("span", {
        id: "timer",
        ref_key: "clock",
        ref: clock,
        class: _normalizeClass({ 'working': working.value, 'not-working': !working.value , 'blink': _unref(blink)})
      }, _toDisplayString(_unref(timer)), 3),
      _createVNode(ActionButton, {
        class: "minute-button",
        id: "add-one-minute-button",
        action: _unref(addOneMinute)
      }, {
        default: _withCtx(() => [
          _createTextVNode(">")
        ]),
        _: 1
      }, 8, ["action"])
    ]),
    (selectedTask.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode("Focus on : "),
          _createElementVNode("span", _hoisted_3, _toDisplayString(selectedTask.value.name), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "Click on a task to focus on it")),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ActionButton, {
          id: "start-stop-button",
          action: startOrStop
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(startOrStopLabel.value), 1)
          ]),
          _: 1
        }),
        _createVNode(ActionButton, {
          id: "skip-button",
          action: skipCurrentPomodoro
        }, {
          default: _withCtx(() => [
            _createTextVNode("SKIP")
          ]),
          _: 1
        }),
        _createVNode(ActionButton, {
          id: "reset-button",
          action: _unref(globalReset)
        }, {
          default: _withCtx(() => [
            _createTextVNode("RESET")
          ]),
          _: 1
        }, 8, ["action"]),
        _createVNode(ActionButton, {
          id: "go-to-first-button",
          action: goBackToFirstPomodoro,
          enabled: _unref(currentPomodoroNumber) != 1 || !working.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("➔1"),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["enabled"])
      ])
    ]),
    _createVNode(ProgressBar),
    _withDirectives(_createElementVNode("div", {
      ref_key: "todoList",
      ref: todoList,
      style: _normalizeStyle([_unref(style), {"position":"fixed"}])
    }, [
      _createVNode(TodoList, {
        selectedTask: selectedTask.value,
        "onUpdate:selectedTask": _cache[1] || (_cache[1] = ($event: any) => ((selectedTask).value = $event))
      }, null, 8, ["selectedTask"])
    ], 4), [
      [_vShow, showTodo.value]
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("button", {
        style: _normalizeStyle([[_unref(isFullscreen) ? 'opacity:0.5' : 'opacity:1'], {"text-align":"left"}]),
        id: "fullscreen-button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)))
      }, [
        _createElementVNode("img", {
          id: "fullscreen-logo",
          src: _unref(fullscreenLogo),
          alt: "fullscreen-logo"
        }, null, 8, _hoisted_8)
      ], 4),
      _hoisted_9,
      _createVNode(ActionButton, {
        id: "clear-data-button",
        action: _unref(clearData),
        style: {"text-align":"right"}
      }, {
        default: _withCtx(() => [
          _createTextVNode("CLEAR DATA")
        ]),
        _: 1
      }, 8, ["action"])
    ])
  ], 4))
}
}

})